import { Container } from '@mui/material';
import React from 'react'
import { Link } from 'react-router-dom';
import LogoSvg from '../svg/logo.svg';

const Footer = () => {
    const getCurrentYear = () => {
        return new Date().getFullYear();
    };

    return (
        <div className="footer-body">
            <Container maxWidth="lg">
                <div className="footer-content">
                    <div className="footer-paysera-logo">
                        <div className="footer-header">
                            <div className="footer-logo">
                                <Link to="/" className="logo"><img src={LogoSvg} alt="Logo" /></Link>
                            </div>
                            <div className="footer-copyright">
                                Copyright ©
                                {' '}
                                {getCurrentYear()}
                                {'. '}
                                Paysera
                                {' '}
                            </div>
                        </div>
                        <img className="instant-krediImg" src="/components/footer/finmo.png" alt="Finmo Logo" />
                    </div>
                    <div className="footer-imgs">
                        {/* <img src="/components/footer/ING.png" alt="Logo" /> */}
                        <img src="/components/footer/Visa_Brandmark_Blue_RGB_2021.png" alt="VISA Logo" />
                        <img src="/components/footer/Mastercard-logo.svg.png" alt="Mastercard Logo" />
                        <img src="/components/footer/Maestro_logo.png" alt="Maestro_logo Logo" />
                        <img src="/components/footer/Apple_Pay_Acceptance_Mark.svg" alt="Apple Pay Logo" />
                        <img src="/components/footer/GPay_Acceptance_Mark_800.png" alt="GPay Logo" />
                        {/* <img src="/components/footer/Revolut-Logo.png" alt="Logo" /> */}
                        {/* <img src="/components/footer/trustly-logo.png" alt="Logo" /> */}
                        {/* <img src="" alt="Logo" /> */}
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Footer